import { ChevronDown } from 'lucide-react';
import Markdown from 'react-markdown';

import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
} from '@/components/animate-ui/primitives/radix/accordion.tsx';
import { IMessage } from '@/shared/api/types/chat-message';

import { MessageWithDelay } from '../message-with-delay/message-with-delay';

interface StatusMessageProps {
  msg: IMessage;
  theme: 'system' | 'light' | 'dark';
}

const StatusMessage = ({ msg, theme }: StatusMessageProps) => {
  const agent = msg.payload.agent;
  const message = msg.payload.message;
  // const stage = msg.payload.stage;
  const reasoning = msg.payload.reasoning;

  return (
    <div
      key={msg.id}
      className={`flex flex-col justify-self-end items-end mb-3 gap-[6px] ${theme === 'light' ? 'text-gray-500' : 'text-gray-200'} text-md w-[300px]`}
    >
      <MessageWithDelay text={message} delay={10} />
      {reasoning && (
        <Accordion type="multiple" /* defaultValue={['item']} */ className="w-full !bg-transparent">
          <AccordionItem
            value={agent}
            className="!bg-card !rounded-lg !py-2 !px-3 !border-none shadow-accent-foreground/20 !shadow-sm"
          >
            <AccordionHeader>
              <AccordionTrigger className="group flex items-center gap-4 justify-between w-full font-bold text-md text-left !bg-transparent text-foreground">
                <span>{`Мысли ${agent}`}</span>
                <ChevronDown className="h-4 w-4 transition-transform duration-300 ease-in-out group-data-[state=open]:rotate-180" />
              </AccordionTrigger>
            </AccordionHeader>
            <AccordionContent className="mt-4 !bg-transparent text-foreground">
              <Markdown>{reasoning}</Markdown>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      )}
    </div>
  );
};

export default StatusMessage;
